import { useTranslation } from "react-i18next";

import w1 from '../../img/a1.svg';
import w2 from '../../img/a2.svg';
import w3 from '../../img/a3.svg';
import w4 from '../../img/a4.svg';

function WhyConsulting() {
  const { t } = useTranslation();

  return (
    <>
      <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
        <p className="host-grotesk leading-[1.2] xl:text-[40px] text-[#2A323F] text-[28px]">{t('about.12')}</p>
        <div className="grid md:gap-[20px] xl:gap-0 grid-cols-1 md:grid-cols-2 mt-[40px] xl:mt-[60px]">
          <div className="flex gap-[20px] xl:gap-[60px] items-start border-b xl:border-r border-[#CECABE] pb-[20px] xl:pb-[52px] pt-[20px] xl:pt-0">
            <img src={w1} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('about.4')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('about.5')}</p>
            </div>
          </div>
          <div className="flex gap-[20px] xl:gap-[60px] items-start justify-end border-b border-[#CECABE] pb-[20px] xl:pb-[52px] pt-[20px] xl:pt-0">
            <img src={w2} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('about.6')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('about.7')}</p>
            </div>
          </div>
          <div className="flex gap-[20px] xl:gap-[60px] items-start pt-[20px] xl:pt-[52px] xl:border-r border-b xl:border-b-0 pb-[20px] xl:pb-0 border-[#CECABE]">
            <img src={w3} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('about.8')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('about.9')}</p>
            </div>
          </div>
          <div className="flex gap-[20px] xl:gap-[60px] items-start pt-[20px] xl:pt-[52px] justify-end border-b xl:border-b-0 pb-[20px] xl:pb-0 border-[#CECABE]">
            <img src={w4} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]" />
            <div className="mt-[10px]">
              <p className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px]">{t('about.10')}</p>
              <p className="text-[#000000B2] xl:max-w-[429px] PtRoot text-[12px] xl:text-[14px] mt-[12px]">{t('about.11')}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhyConsulting;
